<script setup lang="ts">
import { useI18n } from 'vue-i18n'
import { computed, watch } from 'vue'
import { DateTime } from 'luxon'
import { faArrowRight } from '@fortawesome/duotone-regular-svg-icons'
import useTime from '~/composables/useTime'
import useTaskLocations from '~/composables/useTaskLocations'
import { useAssignTask } from '~/composables/useAssignTask'
import { SHARE_TAG } from '~/composables/useAssignTags'
import SharedContentStudentCard from '~/components/shared/SharedContentStudentCard.vue'

const hasTasks = defineModel('hasTasks', { default: false })

const { t } = useI18n()
const { currentWeekNumber } = useTime()

const { tasks: unfilteredTasks, isLoading: isLoadingTasks } = useAssignTask({
  tags: [SHARE_TAG],
  additionalParams: computed(() => ({ week: currentWeekNumber }))
})

const tasks = computed(() => unfilteredTasks.value?.filter(task => (!task.startDate) || task.startDate < DateTime.now()))

const { enrichedTasks, isLoadingLocations } = useTaskLocations(tasks)

watch(enrichedTasks, () => {
  if (!enrichedTasks.value?.length)
    return
  hasTasks.value = true
})
</script>

<template>
  <div v-if="!isLoadingTasks && tasks?.length" class="border-seagreen-30 bg-seagreen-10 text-violet-60 mt-6 w-full rounded-lg border-2 px-8 py-6">
    <h2 class="mb-4 text-xl font-bold" v-text="`${t('shared.latestFromTeacher')}:`" />
    <div class="flex flex-col gap-8 md:flex-row md:items-center">
      <div v-if="isLoadingLocations" v-text="t('loading')" />
      <ul v-else class="grid grid-cols-1 gap-8 md:w-3/5 md:grid-cols-2">
        <SharedContentStudentCard
          v-for="task in enrichedTasks.slice(0, 2)"
          :key="`task-${task.taskId}`"
          :task
        />
      </ul>
      <router-link class="group pointer-events-auto flex flex-col items-center focus-visible:ring" to="/fra-laerer">
        <div class="bg-seagreen-40 group-hover:bg-seagreen-30 flex size-32 items-center justify-center rounded-full border-2 border-transparent text-white transition">
          <font-awesome-icon
            :icon="faArrowRight"
            size="5x"
          />
        </div>
        <span class="border-seagreen-40 text-seagreen-50 -mt-2 rounded-lg border-2 bg-white px-3 py-1 text-2xl font-bold" v-text="t('shared.allFromTeacher')" />
      </router-link>
    </div>
  </div>
</template>
